<template>
  <div>
    <div class="bjffff"></div>
    <div class="content">
      <div class="contentBox">
        <!-- <div class="serchBox">
          <div class="logoImg">
            <img src="../../assets/img/logo-p.png" alt="" srcset="" />
          </div>
          <div class="inpBox">
            <div class="inp">
              <div class="search">
                <div class="iconfont icon-search"></div>
              </div>
              <div class="shu"></div>
              <input type="text" placeholder="请输入视频名称" v-model="seachName" name="" id="" @keyup.enter="cpSearchClick" />
              <div class="searchBtn" @click="cpSearchClick">搜索</div>
            </div>
            <div class="textBox">
              <div class="txt" v-for="item in keywords" @click="keywordsClick(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div> -->
        <div class="cad-page">
          <!-- 标题 -->
          <div class="cad-title">CAD介绍</div>

          <!-- 产品介绍 -->
          <section class="cad-section cad-product">
            <div class="cad-left">
              <div class="cad-section-title">
                <span class="cad-title-icon">
                  <img src="../../assets/img/vid1.png" alt="" srcset="">
                </span>
                产品介绍
              </div>

              <div class="cad-intro-box">
                <p>
                  CAD智能模板系统是一套面向服装制版、模板机、雕刻机加工场景的智能化制版工具。系统以CAD图形处理能力为基础，结合AI模板生成与工艺学习能力，帮助企业将传统“人工绘制模板”的流程升级为“智能生成快速调整、批量输出”的数字化制版流程。
                </p>
                <p>
                  系统支持从初始裁片快速生成模板，并可对线条、孔位、槽位、边距、吃量、标签等细节进行精修，既提升制版效率，又保留师傅的工艺经验。随着版本升级，系统还可学习历史模板、工艺规则和制版习惯，逐步形成企业自己的AI工艺模型，实现不同尺码、不同规格模板的自动适配与批量生成。
                </p>
              </div>

              <div class="cad-section-title cad-position-title">
                <span class="cad-title-icon">
                  <img src="../../assets/img/vid2.png" alt="" srcset="">
                </span>
                定位
              </div>

              <div class="cad-position-box">
                从“CAD工具提效”升级到”AI工艺学习”，让模板设计更快、更准、更标准。
              </div>
            </div>

            <!-- 图片预留位置 -->
            <div class="cad-preview">
              <!-- 后期替换成图片即可：
      -->
              <a-carousel autoplay :autoplaySpeed="5000">
                <div class="imgs" >
                  <img src="../../assets/img/cad5-1.png" alt="CAD智能模板系统">
                </div>
                <div class="imgs" >
                  <img src="../../assets/img/cad5.png" alt="CAD智能模板系统">
                </div>
              </a-carousel>
            </div>
          </section>

          <!-- <div class="typeCont">
            <div class="title">{{ activeVideoCategoryName || '视频教程' }}</div>
          </div>
          <div class="conts">
            <div class="box" v-for="item in list" @click="jump(item.id)">
              <div class="left">
                <div class="img imgon">
                  <img :src="$imgUrl + item.openpath" alt="">
                </div>
                <div class="img imgoff">
                  <img :src="$imgUrl + item.closepath" alt="">
                </div>
                <div class="txt">{{ item.name }}</div>
              </div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div> -->
          <!-- CAD视频教程 -->
          <section ref="videoSection" class="cad-section cad-video-section" aria-labelledby="cad-video-title">
            <div class="cad-video-heading">
              <div>
                <div id="cad-video-title" class="cad-video-title">视频教程</div>
                <div class="cad-video-desc">选择分类，跟随视频快速掌握工具操作与工艺流程</div>
              </div>
              <div class="cad-video-total">
                <span class="cad-video-total-dot"></span>
                {{ totalCount ? '共 ' + totalCount + ' 个视频' : '课程持续更新' }}
              </div>
            </div>

            <div class="cad-video-categories" role="tablist" aria-label="视频分类">
              <button
                v-for="category in videoCategories"
                :key="category.id"
                type="button"
                role="tab"
                class="cad-video-category"
                :class="{ active: activeVideoCategory === category.id }"
                :aria-selected="activeVideoCategory === category.id"
                :disabled="!judge"
                @click="videoCategoryClick(category.id)"
              >
                <span>{{ category.name }}</span>
              </button>
            </div>

            <div v-if="list.length" class="cad-video-grid">
              <article
                class="cad-video-card"
                v-for="item in list"
                :key="'video-' + item.id"
                role="button"
                tabindex="0"
                :aria-label="'观看视频：' + item.name"
                @click="jump(item.id)"
                @keyup.enter="jump(item.id)"
              >
                <div class="cad-video-cover">
                  <div class="cad-video-cover-placeholder">
                    <span>CAD</span>
                  </div>
                  <img
                    v-if="item.image"
                    :src="$imgUrl + item.image"
                    :alt="item.name"
                    @error="handleVideoCoverError"
                  >
                  <div class="cad-video-cover-shade"></div>
                  <!-- <span class="cad-video-label">视频教程</span> -->
                  <span class="cad-video-play" aria-hidden="true">
                    <i></i>
                  </span>
                </div>
                <div class="cad-video-card-body">
                  <div class="cad-video-card-title" :title="item.name">{{ item.name }}</div>
                  <div class="cad-video-card-footer">
                    <span class="cad-video-watch">
                      <i class="cad-video-watch-icon"></i>
                      点击观看
                    </span>
                    <span class="cad-video-action">立即学习 <i>→</i></span>
                  </div>
                </div>
              </article>
            </div>

            <div v-else class="cad-video-empty">
              <span class="cad-video-empty-icon">
                <i></i>
              </span>
              <div class="cad-video-empty-title">{{ judge ? '暂无视频课程' : '正在加载视频课程...' }}</div>
              <div class="cad-video-empty-desc">精彩的CAD教学内容将在这里展示</div>
            </div>

            <div v-if="totalCount > page.pageSize" class="cad-video-pagination">
              <a-pagination
                :current="page.pageNo"
                :page-size="page.pageSize"
                :total="totalCount"
                :show-size-changer="false"
                @change="pageOnChange"
              />
            </div>
          </section>
          <!-- CAD特色功能 -->
          <section v-if="isFirstVideoCategory" class="cad-section">
            <div class="cad-subtitle">CAD特色功能</div>

            <div class="cad-feature-grid">
              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid3.png" alt="">
                </div>
                <div class="cad-feature-title">一键成图，快速生成模板</div>
                <div class="cad-feature-desc">
                  从“CAD工具提效“升级到”AI工艺学习”，让模板设计更快、更准、更标准。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid4.png" alt="">
                </div>
                <div class="cad-feature-title">支持人工精修，贴合实际生产</div>
                <div class="cad-feature-desc">
                  生成后的模板并不是固定不可改，而是支持对每一条线、每一个孔位、槽位、边距、弧度、长度和间距进行单独调整，方便制版师根据实际工艺继续优化。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid5.png" alt="">
                </div>
                <div class="cad-feature-title">套码与全码展开，提高批量制版效率</div>
                <div class="cad-feature-desc">
                  系统支持按照尺码规则自动套码，并可一键展开全部尺码样片，方便进行比对、排料、审核和批量输出。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid6.png" alt="">
                </div>
                <div class="cad-feature-title">自动处理切割路径，适配模板机与雕刻机</div>
                <div class="cad-feature-desc">
                  系统支持按照尺码规则自动套码，并可一键展开全部尺码样片，方便进行比对、排料、审核和批量输出。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid7.png" alt="">
                </div>
                <div class="cad-feature-title">线型、标签、槽位智能同步</div>
                <div class="cad-feature-desc">
                  支持线型、线宽、线色、标签、槽位等信息快速同步，减少重复设置，提升模板输出的一致性和规范性。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid8.png" alt="">
                </div>
                <div class="cad-feature-title">AI学习工艺经验，形成企业专属模型</div>
                <div class="cad-feature-desc">
                  系统可学习历史模板数据、线条规则、偏移规则、开槽方式、孔位规则和师傅调整习惯，逐步沉淀企业自己的工艺模型。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid9.png" alt="">
                </div>
                <div class="cad-feature-title">自动适配不同尺码与规格</div>
                <div class="cad-feature-desc">
                  面对不同尺码、不同规格、不同大小的裁片，AI可根据已学习的模型自动生成更符合生产要求的模板，减少逐码修改和重复劳动。
                </div>
              </div>

              <div class="cad-feature-card">
                <div class="cad-feature-icon">
                  <img src="../../assets/img/vid10.png" alt="">
                </div>
                <div class="cad-feature-title">提升标准化，减少人为误差</div>
                <div class="cad-feature-desc">
                  通过统一规则和模型输出，系统可以减少不同人员、不同班次、不同经验水平带来的制版差异，让模板生产更加稳定、标准。
                </div>
              </div>
            </div>
          </section>
        </div>
        <!-- <div class="fenye" v-if="totalCount > 20">
          <a-pagination :default-current="page.pageNo" v-model="page.pageNo" :total="totalCount" :page-size="6"
            @change="pageOnChange" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  name: "",
  data() {
    return {
      totalCount: 0,
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 12,
        type_id: null,
      },
      list: [],
      seachName: '',
      keywords: [],
      activeVideoCategory: null,
      videoCategories: [],
    };
  },
  created() {
    this.videoCategoriesGet();
  },
  methods: {
    jump(id) {
      this.$router.push({
        path: "/vidCont",
        query: {
          id: id,
        },
      });
    },
    pageOnChange(i) {
      if (i === this.page.pageNo || !this.judge) {
        return;
      }
      this.list = [];
      this.page.pageNo = i;
      this.listGet();
      this.$nextTick(() => {
        if (this.$refs.videoSection) {
          this.$refs.videoSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    handleVideoCoverError(event) {
      event.target.style.display = "none";
    },
    videoCategoriesGet() {
      this.$get("/web/configuration_gets", { type: "video" }).then((res) => {
        this.videoCategories = Array.isArray(res.data) ? res.data : [];
        if (this.videoCategories.length) {
          this.videoCategoryClick(this.videoCategories[0].id);
        }
      });
    },
    videoCategoryClick(id) {
      if (this.activeVideoCategory === id && this.list.length) {
        return;
      }
      this.activeVideoCategory = id;
      this.page.type_id = id;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
    },
    cpSearchClick() {
      // if (!this.cpName) {
      //   this.$message.warning("搜索内容不能为空");
      //   return;
      // }
      this.page.name = this.seachName;
      this.page.pageNo = 1;
      this.list = [];
      this.totalCount = 0;
      this.listGet();
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/web/video_list_gets", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (!this.totalCount) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            this.list.unshift(e)
          }
          // this.list = res.data;
        } else {
          if (this.page.pageNo != 1) {
            this.$message.warning("已展示全部内容");
          }
        }
      });
    },
  },
  mounted() { },
  computed: {
    activeVideoCategoryName() {
      const category = this.videoCategories.find((item) => item.id === this.activeVideoCategory);
      return category ? category.name : '';
    },
    isFirstVideoCategory() {
      return this.videoCategories.length > 0
        && this.activeVideoCategory === this.videoCategories[0].id;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;

  .contentBox {
    width: 1440px;
    margin: auto;
    background-color: #f5f4f4;
    box-sizing: border-box;
    padding: 10px 15px;
  }

  .serchBox {
    display: flex;
    padding: 30px 70px;
    align-items: center;

    .logoImg {
      width: 250px;
    }

    .inpBox {
      width: calc(100% - 250px);
      box-sizing: border-box;
      padding-left: 50px;

      .inp {
        border: 2px solid #f66;
        background-color: #fff;
        width: 100%;
        height: 50px;
        border-radius: 10px;
        display: flex;
        overflow: hidden;
        align-items: center;
        position: relative;

        .search {
          width: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          .iconfont {
            font-size: 24px;
            color: #999;
          }
        }

        .shu {
          width: 2px;
          height: 20px;
          background-color: #c9c9c9;
        }

        input {
          width: calc(100% - 67px);
          height: 100%;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .searchBtn {
          cursor: pointer;
          width: 90px;
          height: calc(100% - 4px);
          position: absolute;
          right: 2px;
          top: 2px;
          background-color: rgb(233, 7, 7);
          color: #fff;
          font-weight: 600;
          font-size: 16px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .textBox {
        margin-top: 10px;
        overflow: hidden;
        padding-left: 5px;

        .txt {
          float: left;
          margin-left: 15px;
          cursor: pointer;
          font-size: 12px;
        }

        .txt:hover {
          color: #f66;
        }
      }
    }
  }

  .typeCont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    height: 60px;
    border-radius: 10px 10px 0 0;
    padding: 0 0;

    .title {
      font-size: 18px;
      font-weight: 600;
    }

    .typeList {
      display: flex;

      .type {
        margin-left: 25px;
        color: #666;
        cursor: pointer;
      }

      .on {
        color: #ff6408;
      }
    }
  }

  .conts {
    overflow: hidden;
    // margin-top: 15px;
    background-color: #fff;
    padding: 0;
    // .cont {
    //   background-color: #fff;
    //   float: left;
    //   margin-right: 15px;
    //   margin-bottom: 15px;
    //   cursor: pointer;

    //   .img {
    //     width: 100%;
    //     position: relative;
    //     height: 260px;

    //     img {
    //       width: 100%;
    //       height: 100%;
    //       object-fit: cover;
    //     }
    //   }

    //   .name {
    //     height: 40px;
    //     padding: 0 15px;
    //     line-height: 40px;
    //   }
    // }

    .box {
      width: calc(16.66% - 12.5px);
      height: 44px;
      cursor: pointer;
      margin-right: 15px;
      margin-bottom: 15px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 8px;
      background-color: #FFEFEF;
      color: #F14E52;
      border: 1px solid #FF8689;
      float: left;

      .left {
        display: flex;
        align-items: center;

        .img {
          width: 16px;
          height: 16px;
          margin-right: 4px;

          img {
            display: block;
          }
        }
      }

      .imgoff {
        display: none;
      }
    }

    .box:nth-child(6n) {
      margin-right: 0;
    }
  }

  .box:hover {
    background: linear-gradient(180deg, #F86575 0%, #F14D52 100%);
    color: #fff;
    border: 1px solid #FF8689;

    .imgon {
      display: none;
    }

    .imgoff {
      display: block;
    }
  }

  .cont:nth-child(3n) {
    margin-right: 0;
  }
}

/* 页面整体 */
.cad-page {
  width: 100%;
  background: #fff;
  padding: 24px 15px 24px;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  color: #303746;
  margin-bottom: 15px;
  border-radius: 12px;
}

/* 顶部标题 */
.cad-title {
  font-size: 18px;
  color: #333b48;
  font-weight: 600;
  margin-bottom: 24px;
}

/* 通用区块 */
.cad-section {
  width: 100%;
  box-sizing: border-box;
}

/* 产品介绍布局 */
.cad-product {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 48px;
}

.cad-left {
  flex: 1;
  max-width: 780px;
}

/* 小标题 */
.cad-section-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: #303746;
  margin-bottom: 14px;
}

.cad-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  color: #ff4d5a;
  font-size: 18px;
  width: 16px;
  height: 16px;
}

/* 产品介绍文字卡片 */
.cad-intro-box {
  width: 100%;
  background: #fff6f7;
  border-radius: 12px;
  padding: 20px 28px;
  box-sizing: border-box;
  color: #3d4350;
  line-height: 1.9;
  font-size: 15px;
}

.cad-intro-box p {
  margin: 0;
  text-indent: 2em;
}

/* 定位 */
.cad-position-title {
  margin-top: 16px;
}

.cad-position-box {
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #ff5965 0%, #ff4758 100%);
  color: #fff;
  border-radius: 9px;
  padding: 0 24px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
}

/* 图片预留区域 */
.cad-preview {
  width: 600px;
  min-width: 420px;
  margin-top: 26px;
  box-sizing: border-box;
  .imgs{
    width: 100%;
    height: 100%;
  }
}

.cad-preview img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 预留占位，后期有图可以删除 */
.cad-preview-placeholder {
  width: 100%;
  height: 100%;
  border: 1px dashed #d8d8d8;
  background: #f8f8f8;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  font-size: 15px;
}

/* CAD视频教程 */
.cad-video-section {
 // margin-top: 42px;
}

.cad-video-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 22px;
}

.cad-video-title {
  position: relative;
  padding-left: 13px;
  font-size: 18px;
  line-height: 1.4;
  color: #303746;
  font-weight: 700;
}

.cad-video-title::before {
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 0;
  width: 4px;
  border-radius: 4px;
  background: linear-gradient(180deg, #ff6870 0%, #f14d52 100%);
  content: "";
}

.cad-video-desc {
  margin-top: 7px;
  padding-left: 13px;
  color: #8b919c;
  font-size: 13px;
}

.cad-video-total {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border: 1px solid #ffd3d5;
  border-radius: 15px;
  background: #fff6f7;
  color: #f14e52;
  font-size: 12px;
}

.cad-video-total-dot {
  width: 6px;
  height: 6px;
  margin-right: 7px;
  border-radius: 50%;
  background: #f14e52;
  box-shadow: 0 0 0 4px rgba(241, 78, 82, 0.1);
}

.cad-video-categories {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  padding: 12px;
  border-radius: 12px;
  background: #fff8f8;
}

.cad-video-category {
  display: inline-flex;
  height: 36px;
  align-items: center;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: #fff;
  color: #656c78;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.cad-video-category:hover,
.cad-video-category:focus {
  border-color: #ffb7ba;
  color: #f14e52;
}

.cad-video-category.active {
  border-color: #f14e52;
  background: linear-gradient(180deg, #f86575 0%, #f14d52 100%);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 5px 12px rgba(241, 78, 82, 0.2);
}

.cad-video-category:disabled {
  cursor: wait;
}

.cad-video-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.cad-video-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #f0e7e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(48, 55, 70, 0.06);
  cursor: pointer;
  outline: none;
  transition: transform 0.24s ease, border-color 0.24s ease, box-shadow 0.24s ease;
}

.cad-video-card:hover,
.cad-video-card:focus {
  border-color: #ffb7ba;
  box-shadow: 0 12px 28px rgba(241, 78, 82, 0.14);
  transform: translateY(-4px);
}

.cad-video-cover {
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #faeded;
}

.cad-video-cover-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 22% 28%, rgba(255, 255, 255, 0.58) 0 7%, transparent 7.5%),
    linear-gradient(135deg, #fff2f3 0%, #ffd9dc 50%, #f6a5aa 100%);
  color: rgba(241, 78, 82, 0.36);
  font-size: 34px;
  font-weight: 800;
  letter-spacing: 4px;
}

.cad-video-cover img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform 0.35s ease;
}

.cad-video-card:hover .cad-video-cover img,
.cad-video-card:focus .cad-video-cover img {
  transform: scale(1.045);
}

.cad-video-cover-shade {
  position: absolute;
  z-index: 2;
  inset: 0;
  background: linear-gradient(180deg, rgba(24, 25, 30, 0.02) 45%, rgba(24, 25, 30, 0.32) 100%);
}

.cad-video-label {
  position: absolute;
  z-index: 3;
  top: 12px;
  left: 12px;
  height: 26px;
  padding: 0 10px;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.92);
  color: #f14e52;
  font-size: 12px;
  line-height: 26px;
  box-shadow: 0 3px 10px rgba(48, 55, 70, 0.1);
}

.cad-video-play,
.cad-video-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6870 0%, #f14d52 100%);
  box-shadow: 0 7px 18px rgba(241, 78, 82, 0.32);
}

.cad-video-play {
  position: absolute;
  z-index: 3;
  top: 50%;
  left: 50%;
  width: 52px;
  height: 52px;
  border: 4px solid rgba(255, 255, 255, 0.94);
  transform: translate(-50%, -50%);
  transition: transform 0.24s ease, box-shadow 0.24s ease;
}

.cad-video-card:hover .cad-video-play,
.cad-video-card:focus .cad-video-play {
  box-shadow: 0 9px 22px rgba(241, 78, 82, 0.42);
  transform: translate(-50%, -50%) scale(1.08);
}

.cad-video-play i,
.cad-video-empty-icon i {
  width: 0;
  height: 0;
  margin-left: 4px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 11px solid #fff;
}

.cad-video-card-body {
  padding: 15px 16px 14px;
}

.cad-video-card-title {
  overflow: hidden;
  color: #303746;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cad-video-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding-top: 12px;
  border-top: 1px solid #f4eded;
  font-size: 12px;
}

.cad-video-watch {
  display: flex;
  align-items: center;
  color: #9a9fa8;
}

.cad-video-watch-icon {
  position: relative;
  width: 15px;
  height: 15px;
  margin-right: 6px;
  border: 1px solid #ff9297;
  border-radius: 50%;
}

.cad-video-watch-icon::after {
  position: absolute;
  top: 4px;
  left: 5px;
  width: 0;
  height: 0;
  border-top: 3px solid transparent;
  border-bottom: 3px solid transparent;
  border-left: 4px solid #f14e52;
  content: "";
}

.cad-video-action {
  color: #f14e52;
  font-weight: 600;
}

.cad-video-action i {
  display: inline-block;
  margin-left: 2px;
  font-style: normal;
  transition: transform 0.2s ease;
}

.cad-video-card:hover .cad-video-action i,
.cad-video-card:focus .cad-video-action i {
  transform: translateX(3px);
}

.cad-video-empty {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed #f1c9cb;
  border-radius: 12px;
  background: #fffafa;
}

.cad-video-empty-icon {
  width: 46px;
  height: 46px;
  margin-bottom: 14px;
}

.cad-video-empty-title {
  color: #4f5663;
  font-size: 15px;
  font-weight: 600;
}

.cad-video-empty-desc {
  margin-top: 6px;
  color: #a2a7af;
  font-size: 12px;
}

.cad-video-pagination {
  display: flex;
  justify-content: center;
  margin-top: 28px;

  /deep/ .ant-pagination-item-active {
    border-color: #f14e52;

    a {
      color: #f14e52;
    }
  }

  /deep/ .ant-pagination-item:hover,
  /deep/ .ant-pagination-prev:hover .ant-pagination-item-link,
  /deep/ .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: #f14e52;

    a {
      color: #f14e52;
    }
  }
}
/* CAD特色功能标题 */
.cad-subtitle {
  font-size: 18px;
  color: #303746;
  font-weight: 600;
  margin-top: 48px;
  margin-bottom: 28px;
}

/* 功能卡片网格 */
.cad-feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px 20px;
}

/* 功能卡片 */
.cad-feature-card {
  min-height: 190px;
  background: #fff6f7;
  border-radius: 12px;
  padding: 22px 18px;
  box-sizing: border-box;
}

.cad-feature-icon {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #ff6870 0%, #ff4056 100%);
  color: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 12px;
  box-shadow: 0 4px 10px rgba(255, 71, 88, 0.22);

  img {
    width: 100%;
    height: 100%;
  }
}

.cad-feature-title {
  font-size: 16px;
  color: #303746;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 18px;
}

.cad-feature-desc {
  font-size: 14px;
  color: #4f5663;
  line-height: 1.75;
}
</style>
